import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../theme';

const LEFT_SIZE = 140;

export const useShipmentOrderPreviewCardStyles = createStyles(({ token }) => ({
  shipmentOrderPreviewCard: {
    width: 252,
    minWidth: 252,
  },
  shipmentOrderPreviewCardSection: {
    margin: `0 ${ThemeSpaces.SPACE_NORM}px`,
    padding: `${ThemeSpaces.SPACE_NORM}px 0 ${token.marginXS}px 0`,
    fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    lineHeight: '16px',

    '& + .TwoLinesSeparator': {
      margin: `0 ${ThemeSpaces.SPACE_NORM_30}px 0 ${ThemeSpaces.SPACE_NORM}px`,
    },

    '> .ant-row': {
      marginRight: -ThemeSpaces.SPACE_NORM,
      marginBottom: ThemeSpaces.SPACE_XXS,

      '> .ant-col:first-child': {
        width: LEFT_SIZE,
      },
      '.label.size-md': {
        width: LEFT_SIZE,
      },
    },

    '&:last-child': {
      paddingBottom: ThemeSpaces.SPACE_NORM_15,
    },

    'h4.ant-typography': {
      lineHeight: 1,
      fontFamily: ThemeFont.FONT_CONDENSED,
      fontWeight: 'bold',
      color: ThemeColors.COLOR_GREY_BLUISH,
    },
  },
  shipmentOrderPreviewWarning: {
    fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    fontWeight: 'normal',
    fontStyle: 'italic',
    color: ThemeColors.COLOR_BLUE2,
    marginTop: token.marginXS,
    textAlign: 'center',
  },
  shipmentOrderPreviewDateLabelWithValue: {
    '&& .label': {
      fontWeight: 'bold',
      fontSize: ThemeFont.FONT_SIZE_XS,
      color: ThemeColors.COLOR_BLUE3,
    },
  },
}));
